module.exports = "img/12.cbc2c1.webp";